module.exports = __webpack_public_path__ + "media/images/miyajima-0995843393d4207b32e36acba4e9de19.jpeg";